function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var DocumentWTick = function DocumentWTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M10.99 16.9a.75.75 0 0 1-.53-.22l-2.3-2.34a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.77 1.8 3.78-3.75c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-4.32 4.28a.75.75 0 0 1-.53.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M17.87 22.75H6.13c-1.59 0-2.88-1.23-2.88-2.75V4c0-1.52 1.29-2.75 2.88-2.75h7.6q.173 0 .341.02.081.004.156.024a2.7 2.7 0 0 1 1.443.756l4.27 4.24a2.7 2.7 0 0 1 .703 1.192q.106.372.107.758V20c0 1.52-1.29 2.75-2.88 2.75m1.37-14.36V20c0 .69-.62 1.25-1.38 1.25H6.13c-.76 0-1.38-.56-1.38-1.25V4c0-.69.62-1.25 1.38-1.25h7.16v2.89c0 1.52 1.23 2.75 2.75 2.75zm-.833-1.5L14.79 3.299V5.64c0 .69.56 1.25 1.25 1.25z",
    clipRule: "evenodd"
  }));
};
export default DocumentWTick;
DocumentWTick.displayName = 'DocumentWTick';